<template>
  <v-sheet
    class="uploadComponent"
    title="Click to grap a file from your PC!"
    :color="dragover ? 'gray lighten-2' : 'white darken-4'"
    width="100%"
  >
    <input
      ref="upload"
      id="fileUpload"
      type="file"
      :accept="accept"
      :multiple="multiple"
      style="display: none"
    />
    <v-container
      ref="dzone"
      id="dropzone"
      tabindex="0"
      style="cursor: pointer"
      class="pa-4 uploadZone"
    >
      <v-row justify="center">
        <v-icon v-if="!dragover" color="purple darken-2" size="75"
          >mdi-cloud-upload-outline</v-icon
        >
        <v-icon v-if="dragover" color="purple darken-2" size="75"
          >mdi-cloud-upload</v-icon
        >
      </v-row>
      <v-row class="ma-4" justify="center">
        <span class="title purple--text text--darken-2">{{ displayText }}</span>
      </v-row>
    </v-container>
    <v-container class="pa-4 previewWrapper" ref="previewContainer">
      <v-row>
        <v-col
          cols="12"
          :sm="multiple ? 12 / itemsPerRow : 6"
          :offset-sm="multiple ? 0 : 3"
          v-for="(file, index) in files"
          :key="index"
        >
          <v-card
            :class="
              isFileSizeLimit(
                !file.existent && typeof file !== 'string'
                  ? file.origFile.size
                  : 0
              )
                ? 'filesizeLimit'
                : ''
            "
          >
            <v-img
              v-if="file.existent || typeof file !== 'string'"
              class="previewImage text-right"
              :src="file.existent ? file.data : file.imageURL"
              :aspect-ratio="16 / 9"
              contain
              width="100%"
            >
              <v-icon
                v-if="!file.uploadResult"
                class="deleteButton"
                color="red"
                @click="removeFile(index)"
                >mdi-close-circle</v-icon
              >
              <v-icon
                v-else-if="file.uploadResult == 'success' && !file.existent"
                class="deleteButton"
                color="success"
                >mdi-check-bold</v-icon
              >
              <v-icon
                v-else-if="file.uploadResult == 'failed' && !file.existent"
                class="deleteButton"
                color="red"
                >mdi-exclamation-thick</v-icon
              >
            </v-img>
            <v-img
              v-else
              class="previewImage text-right"
              :src="file"
              :aspect-ratio="16 / 9"
              contain
              width="100%"
            >
              <v-icon
                class="deleteButton"
                color="red"
                @click="removeFile(index)"
                >mdi-close-circle</v-icon
              >
            </v-img>
            <div
              class="ma-4"
              v-if="
                !file.existent &&
                typeof file !== 'string' &&
                isFileSizeLimit(file.origFile.size)
              "
            >
              Die Datei ist größer als das Limit von {{ maxFileSize }} MB
            </div>
            <div class="ma-4" v-if="!file.existent && typeof file !== 'string'">
              Größe: {{ getFileSize(file.origFile.size) }}
            </div>
            <div class="ma-4">
              Name: {{ file.existent ? file.filename : file.name }}
            </div>
            <v-progress-linear
              v-if="!file.existent && file.upload"
              color="orange"
              stream
              height="5"
              :buffer-value="file.uploadProgress"
            />
            <div style="height: 5px" v-else-if="!file.upload"></div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pa-4 infoContainer">
      <v-row>
        <v-col v-show="!hideImageCount" sm="2">
          Bilder: {{ files.length }} von {{ maxFiles }}
        </v-col>
        <v-col v-show="!hideTotalUploadSize" sm="2">
          Gesamtgröße: {{ getFileSize(getTotalSize) }}
        </v-col>

        <v-col sm="3" class=".d-flex.justify-end">
          <v-btn
            v-show="!autoUpload && !hideClearButton"
            small
            class="white--text"
            color="red"
            :disabled="files.length == 0"
            @click="removeAll()"
            ><v-icon>mdi-close</v-icon>Alle entfernen</v-btn
          >
        </v-col>
        <v-col sm="3">
          <v-btn
            :disabled="files.length == 0"
            @click="upload()"
            v-show="!autoUpload && !hideUploadButton"
            small
            color="success"
            ><v-icon>mdi-upload</v-icon>Upload starten</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  props: {
    autoUpload: {
      type: Boolean,
      default: false,
    },
    axiosInstance: {
      type: Function,
      required: true,
    },
    displayText: {
      type: String,
      default: "Drag'n drop or click to upload file!",
    },
    itemsPerRow: {
      type: Number,
      default: 4,
    },
    hideUploadButton: {
      type: Boolean,
      default: false,
    },
    hideClearButton: {
      type: Boolean,
      default: false,
    },
    hideTotalUploadSize: {
      type: Boolean,
      default: false,
    },
    hideImageCount: {
      type: Boolean,
      default: false,
    },
    numberFormat: {
      type: String,
      default: "en-EN",
    },
    accept: {
      type: String,
      default: ".jpg,.png",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    appendMode: {
      type: Boolean,
      default: true,
    },
    maxConcurrentUploads: {
      type: Number,
      default: 3,
    },
    maxFiles: {
      type: Number,
      default: 10,
    },
    maxFileSize: {
      type: Number,
      default: 2 /* <= Size in Megabytes */,
    },
    maxTotalSize: {
      type: Number,
      require: false /* <= Size in Megabytes */,
    },
    previewWrapperClass: {
      type: String,
      default: "previewWrapper",
    },
    uploadProgress: {
      type: Function,
      default: null,
    },
    uploadUrl: {
      type: String,
      required: true,
    },
    existentItems: {
      type: [String, Array],
      default: function () {
        return [];
      },
    },
  },
  data: () => ({
    dragover: false,
    formUpload: false,
    formData: [],
    files: [],
    maxFilesReached: false,
    errorFiles: [],
  }),
  methods: {
    removeAll() {
      this.files = this.files.filter((el) => el.existent === true);
      if (!this.isFileSizeLimit) {
        this.maxFilesReached = false;
      }
      this.$emit("imagesCleared", this);
    },
    removeFile(index) {
      let removeditem = this.files.splice(index, 1);
      if (!this.isFileSizeLimit) {
        this.maxFilesReached = false;
      }
      this.$emit("imageRemoved", { src: this, file: removeditem, index });
    },
    isFileSizeLimit(size) {
      return size > this.maxFileSize * 1024 * 1024;
    },
    getFileSize(size) {
      const kb = size / 1024;
      const mb = kb / 1024;

      if (kb < 1024) {
        return (
          new Intl.NumberFormat(this.numberFormat, {
            maximumSignificantDigits: 3,
          }).format(kb) + " KB"
        );
      } else {
        return (
          new Intl.NumberFormat(this.numberFormat, {
            maximumSignificantDigits: 3,
          }).format(mb) + " MB"
        );
      }
    },
    filesSelected(fileList) {
      this.dragover = false;
      //if append mode is off, clear the files array

      this.$emit("filesSelected", {
        files: this.files,
        newFiles: fileList,
      });

      for (let index = 0; index < fileList.length; index++) {
        if (this.files.length >= Number.parseInt(this.maxFiles)) {
          this.maxFilesReachedEvent();
          break;
        }

        const imageURL = URL.createObjectURL(fileList[index]);

        const fileItem = {
          origFile: fileList[index],
          imageURL: imageURL,
          name: fileList[index].name,
          upload: false,
          uploadProgress: 0,
          uploadResult: null,
          key: `${new Date().getTime()}-${index}`,
        };
        this.files.push(fileItem);

        if (this.autoUpload) {
          this.uploadFile(fileItem);
        }
      }
    },
    maxFilesReachedEvent() {
      if (!this.maxFilesReached) {
        this.$emit("maxFilesReached", { max: this.max });
        this.maxFilesReached = true;
      }
      //this.maxFilesReached = false;
    },
    traverseFileTree(item, path) {
      if (this.maxFilesReached) {
        return false;
      }
      //need to set this to component const, cause this is out of scope in dirReader function
      const component = this;
      path = path || "";
      if (item.isFile) {
        // Get file
        item.file(function (file) {
          //console.log("File:", path + file.name);
          component.filesSelected([file]);
        });
      } else if (item.isDirectory) {
        // Get folder contents
        var dirReader = item.createReader();

        dirReader.readEntries(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            component.traverseFileTree(entries[i], path + item.name + "/");
          }
        });
      }
    },
    upload() {
      this.$emit("uploadStarted", this);
      this.files.forEach((file) => {
        if (typeof file !== "string") {
          this.uploadFile(file);
        }
      });
      this.$emit("uploadFinshed", this);
    },
    uploadFile(fileItem) {
      const component = this;

      if (fileItem.existent || typeof file === "string") {
        return false;
      }

      if (this.isFileSizeLimit(fileItem.origFile.size)) {
        fileItem.uploadResult = "failed";
        this.$emit("fileUploadError", new Error("File is too big"));
        return false;
      }

      if (this.axiosInstance) {
        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            var percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );

            component.$emit("uploadProgress", percentCompleted);
            //component.files[0].uploadProgress = percentCompleted;
            fileItem.uploadProgress = percentCompleted;
          },
        };

        let fileForm = new FormData();
        fileForm.append("files", fileItem.origFile);
        if (this.formData && this.formData instanceof Array) {
          for (let index in this.formData) {
            fileForm.append(
              this.formData[index].name,
              this.formData[index].value
            );
          }
        }

        fileItem.upload = true;

        this.axiosInstance
          .put(this.uploadUrl, fileForm, config)
          .then((result) => {
            fileItem.uploadResult = "success";

            this.$emit("fileUploadSuccess", result);
          })
          .catch((error) => {
            fileItem.uploadResult = "failed";

            this.$emit("fileUploadError", error);
          })
          .finally(() => {
            fileItem.upload = false;
          });
      }
    },
    setExistentItems(items) {
      if (!items || items.length == 0) {
        return false;
      } else if (typeof items === "string") {
        items = [items];
      }

      for (let index in items) {
        let item = items[index];
        if (typeof item !== "string") {
          item.existent = true;
        }

        this.files.push(items[index]);
      }
    },
  },
  computed: {
    getTotalSize() {
      let size = 0;
      for (let file of this.files) {
        if (!file.existent && typeof file !== "string" && file.origFile) {
          size += file.origFile.size;
        }
      }
      return size;
    },
  },

  created() {},

  mounted() {
    const dropzone = this.$refs.dzone;
    const fileupload = this.$refs.upload;
    const previewZone = this.$refs.previewContainer;

    if (this.existentItems && this.existentItems.length > 0) {
      this.setExistentItems(this.existentItems);
    }
    // register listeners on your dropzone / v-sheet
    if (dropzone) {
      //File input change event
      fileupload.addEventListener("change", (e) => {
        e.preventDefault();
        //Clear files array on appendMode = false or multiple = false or autoUpload = true
        if (!this.appendMode || !this.multiple || this.autoUpload) {
          this.files = [];
        }
        //Add files to global files array
        this.filesSelected(e.target.files);
      });

      //Click event
      dropzone.addEventListener("click", (e) => {
        e.preventDefault();
        if (fileupload) {
          fileupload.click();
        }
      });

      dropzone.addEventListener("keypress", (e) => {
        e.preventDefault();
        if (e.key === "Enter") {
          if (fileupload) fileupload.click();
        }
      });

      previewZone.addEventListener("dragenter", (e) => {
        e.preventDefault();
      });
      previewZone.addEventListener("dragover", (e) => {
        e.preventDefault();
      });

      // register all drag & drop event listeners
      dropzone.addEventListener(
        "dragenter",
        (e) => {
          e.preventDefault();
          this.dragover = true;
        },
        false
      );
      dropzone.addEventListener(
        "dragleave",
        (e) => {
          e.preventDefault();
          this.dragover = false;
        },
        false
      );
      dropzone.addEventListener(
        "dragover",
        (e) => {
          e.preventDefault();
          this.dragover = true;
        },
        false
      );
      dropzone.addEventListener(
        "drop",
        (e) => {
          e.preventDefault();
          if (e.dataTransfer) {
            //Clear files array on appendMode = false or multiple = false or autoUpload = true
            if (!this.appendMode || !this.multiple || this.autoUpload) {
              this.files = [];
            }

            var items = e.dataTransfer.items;
            for (var i = 0; i < items.length; i++) {
              // webkitGetAsEntry is where the magic happens
              var item = items[i].webkitGetAsEntry();
              if (item) {
                this.traverseFileTree(item);
              }
            }
          }
        },
        false
      );
    }
  },
};
</script>

<style scoped>
.uploadComponent {
  padding: 5px !important;
  border: 1px solid #ddd !important;
  border-radius: 5px !important;
}
.uploadZone {
  border: 2px dashed gray !important;
}

.previewWrapper {
  height: 280px;
  max-height: 500px;
  overflow: auto;
}

.previewImage {
  max-height: 100px;
  height: 100px;
}

.deleteButton {
  background-color: rgba(0, 0, 0, 0.5);
  padding: 3px;
  border-radius: 50%;
}
.deleteButton:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

.filesizeLimit {
  background-color: rgba(255, 100, 100, 0.9);
}

.infoContainer {
}
</style>
